<template>
<div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <div class="d-flex mb-2 justify-content-end align-items-start">
                    <!-- Title -->
                    <p class="flex-grow-1">{{ $t('palette') }}</p>
                </div>
                <!-- Form -->
                <!-- Name -->
                <div role="group" class="form-group">
                <label class=""> {{ $t('nameMandatory') }}</label>
                    <CInput type="text" v-model="palette.name" :invalid-feedback="errorOutput['Name']" :is-valid="genericValidator(palette.name, attemptedSubmit) && errorValidator('Name')"></CInput>
                </div>
                <!-- Colors -->
                <div role="group" class="form-group">
                <label class=""> {{ $t('colorsMandatory') }}</label>
                    <ColorsPicker v-model="palette.colors" :title="$t('colors')" :is-valid="genericValidator(palette.colors, attemptedSubmit) && errorValidator('Colors')" :invalid-feedback="errorOutput['Colors']"></ColorsPicker>
                </div>
                <!-- Action button + submitting -->  
                <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                <CButton v-else type="button" class="btn btn-primary align-self-end" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                <!-- Loading -->
                <FormLoading v-if="loading"></FormLoading>
            </CCardBody>
        </CCard>
    </CCol>
    <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
</div>
</template>
 
<script>
import { mapState } from 'vuex'
import router from '@/router/index';

import { deepClone } from "@/helpers/utils.js";
import { CONSTANTS } from '@/helpers/consts';
import { genericValidator, errorValidator } from "@/helpers/utils.js";

import Palette from "@/classes/Palette";

import ColorsPicker from '@/controls/ColorsPicker.vue'
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import OptionsDropdown from '@/controls/OptionsDropdown.vue'
import FormLoading from '@/controls/FormLoading.vue'

  export default {
    components: { ConfirmationPopUp, OptionsDropdown, FormLoading, ColorsPicker },
    props:{    
        basePalette:
        {
            type: Object,
            default: null,
        },
        baseName:
        {
            type: String,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
    },
    data()
    {
        return {
            attemptedSubmit: false,
            palette: new Palette([]),
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage:"",
        }
    },
    mounted: function()
    {
        this.resetPalette();
    },
    computed:
    {
        ...mapState('palettes', ['putPaletteOutput']),
        ...mapState('palettes', ['postPaletteOutput']),
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
            var result = this.alertOutput && Array.isArray(this.alertOutput) ? this.alertOutput : [];

            if(!this.palette.colors || !this.palette.colors.length) result['Colors'] = this.$i18n.t("validateColors");

            return result;
        },
        name: function () {
            return this.basePalette || this.baseName ? (this.basePalette ? this.basePalette.name : this.baseName) : null;
        }
    },
    methods:{
        genericValidator,
        errorValidator,
        resetPalette(){
            if(!this.basePalette)
            {
                this.palette = new Palette([]);
            }
            else
            {
                this.palette = deepClone(new Palette, this.basePalette);    
            }
        },
        submitClicked(){
            this.attemptedSubmit = true;

            // Emit event
            if(this.palette.isValid())
            {
                this.submitting = true;
                this.$emit('submit-requested', this.palette);
            }
        },
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            router.push({name: "PalettesList"});
        },
        onProcessTask: function(val)
        {
            if(val != null)
            {
                if(val)
                {
                    this.showConfirmationPopup = true;
                }

                this.submitting = false;
            }
        }
    },
    watch:
    {
        putPaletteOutput: function(val)
        {
            this.onProcessTask(val);
        },
        postPaletteOutput: function(val)
        {
            this.onProcessTask(val);
        },
        basePalette: function()
        {
            this.resetPalette();
        },
        alertOutput: function()
        {
            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        }
    }
  }
</script> 